import { expandFieldKeys, isFieldConfigured } from './pecFieldSelection';

/**
 * True when a `lockAfterSave` field already holds a value that came back from the server — judged
 * against the drawer's loaded snapshot, never live form state, so a just-typed value stays editable.
 */
export const isFieldLockedAfterSave = (
    config: any,
    savedFormData: Record<string, any> = {},
    sectionKey: string,
    fieldKey: string,
): boolean => !!config?.lockAfterSave && isFieldConfigured(savedFormData, expandFieldKeys(sectionKey, fieldKey, config, false));

/** An explicit config `readonly` overrides the lock and the drawer-level readonly alike. */
export const applyReadonlyOverride = (config: any, isDisabled: boolean): boolean => config?.readonly ?? isDisabled;
